webpackJsonp([38416693584938],{

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 1: Learn about gender bias in the hiring process'
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '20', max: '100' },
	          '20 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Gender bias refers to a person receiving different treatment based on the person\'s real or perceived gender identity. Gender bias can lead to higher levels of stress, anxiety, depression, and post-traumatic stress disorder in women.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          '* In this step, you will learn about gender bias in the hiring process: people who identify as women are less likely to be hired even if they perform equally well in interviews, especially regarding male-dominant jobs like software developers.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          '* We want an algorithm to help make hiring decisions. However, drawing on past data would simply reinforce the biases contained.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          '* Now, imagine that we want to build a classifier that will make hiring decisions. We would like our algorithm to correct for gender bias. We can do it in two ways: (1) removing bias in training data; (2) not considering the gender-related characteristics in the training process.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'So good so far?'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/0-introduction/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/2-acquire/' },
	          'Next step'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-1-bias-js-ffdc3ad2866d21111e36.js